import { render } from "./map.vue?vue&type=template&id=545a701a"
import script from "./map.vue?vue&type=script&lang=js"
export * from "./map.vue?vue&type=script&lang=js"

import "./map.vue?vue&type=style&index=0&id=545a701a&lang=css"

import exportComponent from "/data/www/shoptok-analytics/frontend/live/live_225/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__